var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { state } from 'lit/decorators.js';
import { SdsContextMenuItem } from './sds-cm-item.lit';
import { classMap } from 'lit/directives/class-map.js';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsContextMenuActionItem = (() => {
    var _SdsContextMenuActionItem__actionMenuOpened_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-cm-action-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsContextMenuItem;
    let __actionMenuOpened_decorators;
    let __actionMenuOpened_initializers = [];
    let __actionMenuOpened_extraInitializers = [];
    var SdsContextMenuActionItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsContextMenuActionItem__actionMenuOpened_accessor_storage.set(this, __runInitializers(this, __actionMenuOpened_initializers, false));
            this.handleActionListClick = (__runInitializers(this, __actionMenuOpened_extraInitializers), (event) => {
                this.dispatchEvent(new CustomEvent(SdsContextMenuActionItem.CM_ACTION_ITEM_CLICKED, {
                    detail: {
                        identifier: event.detail.id,
                    },
                }));
            });
            this.handleActionMenuStateChange = (event) => {
                this._actionMenuOpened = event.detail.opened;
            };
        }
        get _actionMenuOpened() { return __classPrivateFieldGet(this, _SdsContextMenuActionItem__actionMenuOpened_accessor_storage, "f"); }
        set _actionMenuOpened(value) { __classPrivateFieldSet(this, _SdsContextMenuActionItem__actionMenuOpened_accessor_storage, value, "f"); }
        render() {
            return this.renderInWrapper(html `
                ${this.renderIcon()}
                <div class="sds-cm-item__content">
                    ${this.renderName()} ${this.renderDescription()}
                </div>
                ${this.renderActionGroup()}
            `);
        }
        renderActionGroup() {
            return html `
            <div class="sds-cm-item__action-group">
                <sds-action-list
                    @sds.action-list.action="${this.handleActionListClick}"
                    @sds.action-list.menu.state="${this.handleActionMenuStateChange}"
                >
                    <slot name="action" slot="action"></slot>
                </sds-action-list>
            </div>
        `;
        }
        getClasses() {
            return classMap({
                'sds-cm-item': true,
                'sds-cm-item--heading': this.heading,
                'sds-cm-item--has-icon': this.withIcon,
                'sds-cm-item--disabled': this.disabled,
                'sds-cm-item--selected': this._actionMenuOpened,
            });
        }
    };
    _SdsContextMenuActionItem__actionMenuOpened_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsContextMenuActionItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __actionMenuOpened_decorators = [state()];
        __esDecorate(_classThis, null, __actionMenuOpened_decorators, { kind: "accessor", name: "_actionMenuOpened", static: false, private: false, access: { has: obj => "_actionMenuOpened" in obj, get: obj => obj._actionMenuOpened, set: (obj, value) => { obj._actionMenuOpened = value; } }, metadata: _metadata }, __actionMenuOpened_initializers, __actionMenuOpened_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenuActionItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CM_ACTION_ITEM_CLICKED = 'sds.cm.action.item.clicked';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenuActionItem = _classThis;
})();
export { SdsContextMenuActionItem };
